// src/lib/http.js
import axios from "axios";
import { BASE_URL } from "../config/api.js";

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

function getToken() {
  try {
    const raw = localStorage.getItem("bb_user");
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u?.token || null;
  } catch {
    return null;
  }
}

const KEY_HEADER = import.meta.env.VITE_API_KEY_HEADER || "x-api-key";
const KEY_VALUE = import.meta.env.VITE_API_KEY_VALUE;

// attach token + api-key
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (KEY_VALUE) config.headers[KEY_HEADER] = KEY_VALUE;
  return config;
});

// unwrap + normalize errors
http.interceptors.response.use(
  (res) => {
    if (res.data.paginate == true) {
      const d = res.data;
      if (d && typeof d === "object" && "data" in d) return d;
      return d;
    } else {
      const d = res.data;
      if (d && typeof d === "object" && "data" in d) return d.data;
      return d;
    }

  },
  (err) => {
    const payload = err?.response?.data;
    const msg =
      payload?.message ||
      err?.message ||
      "Something went wrong";
    if (err?.response?.status === 401 && !err?.config?.skipAuthClear) {
      localStorage.removeItem("bb_user");
    }
    const wrapped = new Error(msg);
    wrapped.status = err?.response?.status;
    wrapped.code = payload?.code || payload?.errorCode || "";
    if (payload?.ticketLimit) wrapped.ticketLimit = payload.ticketLimit;
    else if (payload?.alreadyBooked != null || payload?.remaining != null) {
      wrapped.ticketLimit = {
        maxTicketsPerUser: payload.maxTicketsPerUser,
        alreadyBooked: payload.alreadyBooked,
        remaining: payload.remaining,
      };
    }
    wrapped.errors = Array.isArray(payload?.errors) ? payload.errors : undefined;
    // No response → network/TLS/CORS failure (transient, worth retrying)
    wrapped.isNetworkError = !err?.response;
    return Promise.reject(wrapped);
  }
);

// Retry GET requests on transient failures (network blips / 5xx) so a hiccup
// on page refresh recovers automatically instead of showing a stuck state.
async function getWithRetry(url, config, retries = 2, delayMs = 700) {
  try {
    return await http.get(url, config);
  } catch (e) {
    const retryable = e?.isNetworkError || (e?.status >= 500 && e?.status < 600);
    if (retries > 0 && retryable) {
      await new Promise((r) => setTimeout(r, delayMs));
      return getWithRetry(url, config, retries - 1, delayMs * 1.6);
    }
    throw e;
  }
}

export const get = (url, config) => getWithRetry(url, config);
export const post = (url, body, config) => http.post(url, body, config);
export const put = (url, body, config) => http.put(url, body, config);
export const patch = (url, body, config) => http.patch(url, body, config);
export const del = (url, config) => http.delete(url, config);

export default http;

/*  // ← अगर API-key सिर्फ register पर चाहिए:
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (KEY_VALUE && /registerUserOTP$/.test(config.url)) {
    config.headers[KEY_HEADER] = KEY_VALUE;
  }
  return config;
});
*/
